import { API_BASE_URL } from '../global/runtime-config';
import { downloadBlob, getCookieByName } from '../global/util';

// Cfm.WebApi ContentController.DownloadFile - File/SaveContent'in zengin metin içeriğine
// gömdüğü URL. Endpoint authenticated olduğu için tarayıcı bunu kendi başına (<img src>
// yüklemesi veya link navigasyonu ile) çekemez; byte'ları buradan authenticated fetch ile
// alıp çağırana veriyoruz.
export const CONTENT_DOWNLOAD_PATH = '/Content/DownloadFile';

// Saklanan HTML'de API tabanının yerini tutan işaret; okurken sunucu onu o anki tabanla
// değiştiriyor (WorkOrderHtmlContentBusiness).
export const API_BASE_URL_SIGNATURE = '#ApiBaseUrlSignature#';

// Bir Content/DownloadFile adresinin önündeki taban; şeması ve host'u ne olursa olsun.
const CONTENT_BASE_PATTERN = new RegExp(`https?://[^\\s"'<>]*?(?=${CONTENT_DOWNLOAD_PATH})`, 'g');

// Editörden çıkan HTML'i saklanacak biçime getirir: adreslerin tabanı işarete çevrilir.
//
// Content/DownloadFile tabanı şemadan ve host'tan bağımsız çevriliyor. Taban yüklemenin
// döndürdüğü adresten geliyor ve sayfanın API tabanıyla aynı olmayabiliyor: SaveContent bir
// süre form alanını okumadığı için `http` adres döndürdü, o adresler veritabanına olduğu gibi
// yazıldı ve https sayfada hiç görünmedi. Böyle bir kayıt düzenlenip kaydedilince düzeliyor.
export function toStoredContent(html) {
  return html
    .replace(CONTENT_BASE_PATTERN, API_BASE_URL_SIGNATURE)
    // replaceAll şart: replace(string, ...) yalnızca ilk eşleşmeyi değiştirir, yani 2+ ek
    // içeren içerikte sonraki URL'ler canlı host'a sabitlenip API adresi değiştiğinde kırılıyordu.
    .replaceAll(API_BASE_URL, API_BASE_URL_SIGNATURE);
}

// Bir Content/DownloadFile adresini sayfanın şu anki API tabanına taşır; başka adreslere dokunmaz.
//
// Adresin kendi tabanı yalnız dosya kimliğini taşımak için var. Eski kayıtlarda bu taban `http`
// olabiliyor (bkz. toStoredContent) ve https sayfadan istenince tarayıcı engelliyordu (mixed
// content). İsteğin her zaman kendi API'mize gitmesi, Authorization başlığının başka bir host'a
// gitmemesini de sağlıyor.
export function toCurrentApiUrl(url) {
  if (!isContentDownloadUrl(url)) return url;
  const parsed = new URL(url, window.location.href);
  return `${API_BASE_URL}${parsed.pathname}${parsed.search}`;
}

export function isContentDownloadUrl(url) {
  // new URL() ayrıştırması pahalı; aday olmayanları ucuz bir substring kontrolüyle eliyoruz.
  if (!url || !url.includes(CONTENT_DOWNLOAD_PATH)) return false;
  try {
    return new URL(url, window.location.href).pathname === CONTENT_DOWNLOAD_PATH;
  } catch {
    return false;
  }
}

async function fetchContent(url) {
  // Vue.http/axios interceptor'ları raw fetch'i kapsamadığı için header elle ekleniyor.
  const response = await fetch(toCurrentApiUrl(url), {
    headers: {
      Authorization: `${getCookieByName('tokenType')} ${getCookieByName('token')}`,
    },
  });
  if (!response.ok) throw new Error(`Content download failed: ${response.status}`);
  return response;
}

// Çağıran, dönen blob: URL'i kullanmayı bitirdiğinde URL.revokeObjectURL ile serbest bırakmalı.
export async function fetchContentBlobUrl(url) {
  const response = await fetchContent(url);
  return URL.createObjectURL(await response.blob());
}

export async function downloadContentFile(url, fallbackName) {
  const response = await fetchContent(url);
  const fileName = fileNameFromDisposition(response.headers.get('Content-Disposition'));
  downloadBlob(await response.blob(), fileName || fallbackName || 'download');
}

function fileNameFromDisposition(disposition) {
  if (!disposition) return null;
  const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
  if (utf8Match) return decodeURIComponent(utf8Match[1]);
  const plainMatch = /filename="?([^";]+)"?/i.exec(disposition);
  return plainMatch ? plainMatch[1] : null;
}
